import { faXmark } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MouseEventHandler } from 'react';

export function XButton({ onClick }: { onClick?: MouseEventHandler<SVGSVGElement> }) {
  return <FontAwesomeIcon icon={faXmark} onClick={onClick} />;
}
